import { bandOf, type NamatAssessment } from '@/lib/assessment/namatAssessment';
import { BAND_STYLE } from './bandStyle';
import { useLanguage } from '@/contexts/LanguageContext';

// The Namat scale as one table cell (spec #86): percentage, band and
// compliance when a valid questionnaire exists, otherwise «لم يُعمل». Shared by
// the manager table and the clinical beneficiaries table (#93).

export function NamatScaleCell({ assessment }: { assessment?: NamatAssessment }) {
  const { t, language } = useLanguage();
  const scale = assessment?.status === 'valid' ? assessment.scale : null;
  if (!scale) {
    // Expired (#94): «لم يُعمل» with the last result greyed and its date.
    const last = assessment?.status === 'expired' ? assessment.scale : null;
    return (
      <div className="flex flex-col" data-testid="scale-not-done">
        <span className="text-muted-foreground">
          {assessment?.status === 'expired' ? t('common.health.scale.expired') : t('common.health.scale.notDone')}
        </span>
        {last && assessment?.filledAt && (
          <span className="text-xs text-muted-foreground/70" data-testid="scale-last-result">
            {t('common.health.scale.lastResult', {
              percent: last.percent,
              date: assessment.filledAt.toLocaleDateString(language === 'ar' ? 'ar-SA-u-ca-gregory' : 'en-GB'),
            })}
          </span>
        )}
      </div>
    );
  }
  const band = bandOf(scale.percent);
  return (
    <div className="flex items-center gap-2" data-testid="scale-cell">
      <span className="font-semibold text-lg">{scale.percent}%</span>
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${BAND_STYLE[band]}`}>
        {t(`common.health.scale.band.${band}`)}
      </span>
      <span className="text-xs text-muted-foreground">
        {t('common.health.scale.compliance')} {scale.compliance.met}/{scale.compliance.of}
      </span>
    </div>
  );
}
